import React from "react";

import { Route, Routes, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Homepage from "./components/Homepage";
import AboutUs from "./components/AboutUs";
import ContactUs from "./components/ContactUs";
import Enquiry from "./components/Enquiry";
import Products from "./components/Products";

// import walkerProducts_json from "./products_walker.json";
// import CSCproducts_json from "./products_commodeStool&chairs.json";
// import WSCproducts_json from "./products_walkingSticks&Crutches.json";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import ProtectedRoute from "./utils/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";

function App() {
  const location = useLocation();
  // Check if the current path is '/admin'
  const isAdminRoute = location.pathname.startsWith("/admin");

  function ScrollToTop() {
    // Extracts pathname property(key) from an object
    const { pathname } = useLocation();

    // Automatically scrolls to top whenever pathname changes
    useEffect(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, [pathname]);
  }

  const PageNotFound = () => {
    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <h1>404 - Page Not Found</h1>
        <p className="text-center">The page you are looking for does not exist.</p>
      </div>
    );
  };

  return (
    <div className="App">
      <AuthProvider>
        {!isAdminRoute && <Header />}
        {!isAdminRoute && <ScrollToTop />}

        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/products">
            {/* <Route path="walkers" element={<Products heading="Walkers" jsonFile={walkerProducts_json} />} />
            <Route path="commode-stool-chairs" element={<Products heading="Commode Stool & Chairs" jsonFile={CSCproducts_json} />} />
            <Route path="walking-sticks-crutches" element={<Products heading="Walking Sticks & Crutches" jsonFile={WSCproducts_json} />} /> */}
            <Route path="walkers" element={<Products heading="Walkers" />} />
            <Route path="commode-stool-chairs" element={<Products heading="Commode Stool & Chairs" />} />
            <Route path="walking-sticks-crutches" element={<Products heading="Walking Sticks & Crutches" />} />
          </Route>
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/enquiry" element={<Enquiry />} />

          <Route path="/admin" element={<AdminLogin />} />
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
        {!isAdminRoute && <Footer />}
      </AuthProvider>
    </div>
  );
}

export default App;
